import React from 'react';
import PropTypes from 'prop-types';
import {DatePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';

const DatePickerFull = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        {...props}
        slotProps={{
          textField: {
            ...props.textFieldProps,
          },
        }}
      />
    </LocalizationProvider>
  );
};

DatePickerFull.propTypes = {
  locale: PropTypes.string,
  textFieldProps: PropTypes.object,
};

export default React.memo(DatePickerFull);
